/**
 * Centre Page Google reviews — scrollable overlay (page height stays fixed).
 */
(function () {
	'use strict';

	function initReviewTextToggles() {
		var toggles = document.querySelectorAll('[data-review-toggle]');

		toggles.forEach(function (button) {
			var reviewText = button.closest('[data-review-text]');
			if (!reviewText) {
				return;
			}

			var content = reviewText.querySelector('[data-review-content]');
			if (!content) {
				return;
			}

			button.addEventListener('click', function () {
				var expanded = 'true' === button.getAttribute('aria-expanded');
				content.classList.toggle('is-collapsed', expanded);
				button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
				button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
			});
		});
	}

	function init() {
		initReviewTextToggles();

		var openBtn = document.querySelector('[data-reviews-open]');
		var panel = document.querySelector('.reviews-panel');
		if (!openBtn || !panel) {
			return;
		}

		var sheet = panel.querySelector('.reviews-panel__sheet');
		var visibleStack = document.querySelector('[data-visible-reviews]');
		var panelStack = panel.querySelector('[data-panel-reviews]');
		var visibleCards = visibleStack ? Array.prototype.slice.call(visibleStack.children) : [];
		var closeTriggers = panel.querySelectorAll('[data-reviews-close]');
		var lastFocused = null;

		function openPanel() {
			lastFocused = document.activeElement;
			if (panelStack) {
				visibleCards.slice().reverse().forEach(function (card) {
					panelStack.insertBefore(card, panelStack.firstChild);
				});
			}
			panel.removeAttribute('hidden');
			panel.setAttribute('aria-hidden', 'false');
			document.body.classList.add('centre-page-reviews-open');
			var closeBtn = panel.querySelector('.reviews-panel__close');
			if (closeBtn) {
				closeBtn.focus();
			}
		}

		function closePanel() {
			panel.setAttribute('aria-hidden', 'true');
			panel.setAttribute('hidden', '');
			document.body.classList.remove('centre-page-reviews-open');
			if (visibleStack) {
				visibleCards.forEach(function (card) {
					visibleStack.appendChild(card);
				});
			}
			if (lastFocused && typeof lastFocused.focus === 'function') {
				lastFocused.focus();
			}
		}

		openBtn.addEventListener('click', openPanel);

		closeTriggers.forEach(function (el) {
			el.addEventListener('click', closePanel);
		});

		document.addEventListener('keydown', function (e) {
			if ('Escape' === e.key && 'false' === panel.getAttribute('aria-hidden')) {
				closePanel();
			}
		});

		// Basic focus trap inside the sheet.
		panel.addEventListener('keydown', function (e) {
			if ('Tab' !== e.key || 'false' === panel.getAttribute('aria-hidden') || !sheet) {
				return;
			}
			var focusable = sheet.querySelectorAll(
				'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
			);
			if (!focusable.length) {
				return;
			}
			var first = focusable[0];
			var last = focusable[focusable.length - 1];
			if (e.shiftKey && document.activeElement === first) {
				e.preventDefault();
				last.focus();
			} else if (!e.shiftKey && document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
